import React, { Suspense, lazy } from 'react'
import { Provider } from 'react-redux'
import { store } from './redux/storeConfig/store'
import ability from './configs/acl/ability'
import { ToastContainer } from 'react-toastify'
import { AbilityContext } from './utility/context/Can'
import { ThemeContext } from './utility/context/ThemeColors'
import { TourProvider } from '@reactour/tour'
import './@core/scss/core.scss'
import './@core/scss/base/bootstrap-extended/_variables.scss'
import './assets/scss/style.scss'
import './@core/components/ripple-button'
import './mainDashboard.css'
import './i18n'
import 'react-big-calendar/lib/css/react-big-calendar.css'
import "react-responsive-carousel/lib/styles/carousel.min.css"
import 'react-medium-image-zoom/dist/styles.css'
import '@styles/react/apps/app-invoice.scss'
import "@styles/react/libs/tables/react-dataTable-component.scss"
import 'prismjs'
import 'prismjs/components/prism-jsx.min'
import 'react-confirm-alert/src/react-confirm-alert.css'
import '@styles/react/libs/flatpickr/flatpickr.scss'
// import * as serviceWorker from './serviceWorker'
import loadable from 'react-loadable'
import { Badge } from 'reactstrap'
// ** sentry
// import * as Sentry from "@sentry/react"
// import { Integrations } from "@sentry/tracing"
// // if (process.env.NODE_ENV !== "development") {

// Sentry.init({
//   dsn: "https://9fc935f9f35e4bddaead413061522b6d@o1117173.ingest.sentry.io/6151042",
//   integrations: [new Integrations.BrowserTracing()],
//   environment: process.env.NODE_ENV.concat("educase"),
//   // Set tracesSampleRate to 1.0 to capture 100%
//   // of transactions for performance monitoring.
//   // We recommend adjusting this value in production
//   tracesSampleRate: 1.0
// })
// // }

const LazyApp = loadable({
    loader: () => import(/* webpackChunkName: 'LazyAppMainApp' */'./App'),
    loading: () => (<></>)
})

// const steps = [
//   {
//     selector: '.first-step',
//     content: 'This is my first Step'
//   }
// ]

function Close({ onClick }) {
    return (
        <button
            onClick={onClick}
            style={{ position: 'absolute', right: 0, top: 0, background: 'transparent', border: 'none', color: 'var(--primary)', fontSize: 20 }}
        >
            <Badge style={{ borderRadius: '50%' }}>
                ×
            </Badge>
        </button>
    )
}

const AppWrapper = () => {
    return (<>
        <Provider store={store}>
            <AbilityContext.Provider value={ability}>
                <ThemeContext>
                    <TourProvider components={{ Close }} scrollSmooth styles={{
                        arrow: base => ({ ...base, color: 'var(--primary)' }),
                        close: base => ({ ...base, color: 'var(--primary)' }),
                        dot: (base, { current }) => ({
                            ...base,
                            background: current ? 'var(--primary)' : '#fff',
                            border: '1px solid #ccc'
                        }),
                        popover: base => ({ ...base, borderRadius: 5, paddingTop: 35, minWidth: 293, maxWidth: 293, textAlign: 'center' }),
                        badge: base => ({ ...base, background: 'var(--primary)' })
                    }}>
                        <LazyApp />
                        <ToastContainer autoClose={2000} hideProgressBar={true} pauseOnHover={true} position="top-center" />
                    </TourProvider>
                </ThemeContext>
            </AbilityContext.Provider>
        </Provider>
    </>)
}

export default AppWrapper